import Rellax from 'rellax'
import AOS from 'aos'
import 'aos/dist/aos.css'

AOS.init({
    disable: 'mobile'
})

new Rellax('.rellax')


/*let debug = document.querySelector('.debug')
if(debug !== null) {
    debug.addEventListener('click', () => {
        rellax.destroy()

        setTimeout(function() {
            new Rellax('.rellax')
        },500)

    })
}*/


document.addEventListener('aos:in', (e) => {

    let className = e.detail.className
    let thisData = e.detail.getAttribute('id')

    if (className.includes('product__recipes-wrapper')) {
        // change recipe image

        let recipe = e.detail.getAttribute('data-recipe')
        let recipeImage = document.querySelector('[data-recipe-image="' + recipe + '"]')
        let recipeImages = document.querySelectorAll('[data-recipe-image]')

        recipeImages.forEach(function(e) {
            e.style.display = 'none'
        })

        recipeImage.style.display = 'block'

        if (!className.includes('separator')) {

            recipeImage.classList.remove('aos-animate')

            setTimeout(() => {
                recipeImage.classList.add('aos-animate')
            })

        }


        // Active submenu item
        let navItem = document.querySelectorAll('.nav__link:not(.nav__link--main)')

        navItem.forEach(function(e) {

            e.parentElement.classList.remove('nav__list-item--active')

            let linkData = e.getAttribute('href')
            linkData = linkData.replace('#', '')

            if (linkData === thisData) {
                e.parentElement.classList.add('nav__list-item--active')
            }

        })

    }


    // Set no traditional
    if (className.includes('separator')) {
        let fixedSection = document.querySelector('.product--fixed')
        //let separator = fixedSection.querySelector('.separator')
        let subTitle = fixedSection.querySelector('.product__section-subtitle span')
        let subTitleData = subTitle.getAttribute('data-no-traditional')
        let elems = fixedSection.querySelectorAll('[data-aos]:not(.product__image-wrapper)')

        /*if (window.location.hash !== '#scroll') {
            separator.scrollIntoView()
        }*/

        elems.forEach((element) => {

            /*let dataAOS = element.getAttribute('data-aos')
            dataAOS = dataAOS.replace('fade-right', 'fade-left')*/

            element.classList.remove('aos-animate')

            setTimeout(() => {

                //element.setAttribute('data-aos', dataAOS)
                subTitle.innerText = subTitleData
                fixedSection.classList.add('product--no-traditional')
            }, 800)

            setTimeout(() => {
                element.classList.add('aos-animate')
            }, 1200)

        })

    }

})


document.addEventListener('aos:out', (e) => {

    let className = e.detail.className
    let thisData = e.detail.getAttribute('id')
    let navItem = document.querySelectorAll('.nav__link:not(.nav__link--main)')

    if (className.includes('product__recipes-wrapper')) {
        let recipe = e.detail.getAttribute('data-recipe')

        let recipeNum = recipe.match(/(\d+)/)[0]

        recipe = recipe.replace(/[0-9]/g, '')
        recipeNum = recipeNum - 1

        let recipeImage = document.querySelector('[data-recipe-image="' + recipe + recipeNum + '"]')
        let recipeImages = document.querySelectorAll('[data-recipe-image]')

        recipeImages.forEach(function (e) {
            e.style.display = 'none'
        })

        if (recipeImage !== null) {
            recipeImage.style.display = 'block'
            recipeImage.classList.remove('aos-animate')

            setTimeout(() => {
                recipeImage.classList.add('aos-animate')
            })
        }

        // Active submenu item
        navItem.forEach(function(e) {

            e.parentElement.classList.remove('nav__list-item--active')

            let linkData = e.getAttribute('href')
            linkData = linkData.replace('#', '')

            if (linkData === thisData && e.parentElement.previousElementSibling !== null) {
                e.parentElement.previousElementSibling.classList.add('nav__list-item--active')
            }

        })

    }

    // Set traditional
    if (className.includes('separator')) {
        let fixedSection = document.querySelector('.product--fixed')
        let subTitle = fixedSection.querySelector('.product__section-subtitle span')
        let subTitleData = subTitle.getAttribute('data-traditional')
        let elems = fixedSection.querySelectorAll('[data-aos]:not(.product__image-wrapper)')

        /*if (window.location.hash !== '#scroll') {
            fixedSection.querySelector('.last-item').scrollIntoView()
        }*/

        elems.forEach((element) => {

            /*let dataAOS = element.getAttribute('data-aos')
            dataAOS = dataAOS.replace('fade-left', 'fade-right')*/

            element.classList.remove('aos-animate')

            setTimeout(() => {
                //element.setAttribute('data-aos', dataAOS)
                subTitle.innerText = subTitleData
                fixedSection.classList.remove('product--no-traditional')
            }, 800)

            setTimeout(() => {
                element.classList.add('aos-animate')
            }, 1200)

        })

    }

})

